
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".rll-youtube-player").forEach(el => {
    const videoUrl = el.dataset.src;

    el.style.cursor = "pointer";
    el.style.position = "relative";
    el.style.paddingBottom = "56.25%";
    el.style.height = "0";
    el.style.background = "#000";
    el.style.overflow = "hidden";

    const thumb = document.createElement("img");
    thumb.src = `https://img.youtube.com/vi/${el.dataset.id}/hqdefault.jpg`;
    thumb.style.position = "absolute";
    thumb.style.width = "100%";
    thumb.style.height = "100%";
    thumb.style.objectFit = "cover";
    thumb.style.top = "0";
    thumb.style.left = "0";

    const playButton = document.createElement("div");
    playButton.innerHTML = `
      <svg width="68" height="48" viewBox="0 0 68 48">
        <path d="M66.52 7.74a8 8 0 0 0-5.64-5.66C56.1 1 34 1 34 1S11.9 1 7.12 2.08A8 8 0 0 0 1.48 7.74 83.4 83.4 0 0 0 0 24a83.4 83.4 0 0 0 1.48 16.26 8 8 0 0 0 5.64 5.66C11.9 47 34 47 34 47s22.1 0 26.88-1.08a8 8 0 0 0 5.64-5.66A83.4 83.4 0 0 0 68 24a83.4 83.4 0 0 0-1.48-16.26z" fill="#f00"/>
        <path d="M45 24 27 14v20" fill="#fff"/>
      </svg>
    `;

    playButton.style.position = "absolute";
    playButton.style.top = "50%";
    playButton.style.left = "50%";
    playButton.style.transform = "translate(-50%, -50%)";
    playButton.style.zIndex = "2";
    playButton.style.pointerEvents = "none";

    el.appendChild(thumb);
    el.appendChild(playButton);

    el.addEventListener("click", () => {
      el.innerHTML = `
        <iframe
          src="${videoUrl}?autoplay=1"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          style="position:absolute;top:0;left:0;width:100%;height:100%;">
        </iframe>
      `;
    });
  });
});
